<template>
  <td>
    <input type="text" class="form-control" v-model="element.name" min="0">
  </td>
  <td>
    <div class="input-group">
      <span class="input-group-text" id="basic-addon1">$</span>
      <input type="number" class="form-control" v-model="element.price" min="0" step="any">
    </div>
  </td>
  <td>
    <input type="number" class="form-control" v-model="element.qty">
  </td>
  <td>$ {{ parseFloat(element.price * element.qty).toFixed(2) }}</td>
</template>

<script>
export default {
  name: 'OrderLineFlight',
  props: ['element'],
}
</script>

<style>

</style>
